interface ProgressRailProps {
  inquired: boolean;
  quoted: boolean;
  contractRequested: boolean;
  booked: boolean;
}

interface StepProps {
  label: string;
  done: boolean;
}

function Step({ label, done }: StepProps) {
  return (
    <div className="flex flex-col items-center gap-1">
      <span
        aria-hidden
        className={`size-2 rounded-full ${done ? 'bg-primary' : 'bg-muted-foreground/30'}`}
      />
      <span className={`text-xs ${done ? 'text-foreground' : 'text-muted-foreground'}`}>
        {label}
      </span>
    </div>
  );
}

function Connector({ done }: { done: boolean }) {
  return (
    <span
      aria-hidden
      className={`mt-[3px] h-px flex-1 ${done ? 'bg-primary' : 'bg-muted-foreground/20'}`}
    />
  );
}

export default function ProgressRail({ inquired, quoted, contractRequested, booked }: ProgressRailProps) {
  const activeLabels = [
    inquired && 'inquired',
    quoted && 'quoted',
    contractRequested && 'contract requested',
    booked && 'booked',
  ].filter(Boolean);
  return (
    <div
      role="status"
      aria-label={`Progress: ${activeLabels.join(', ') || 'not started'}`}
      className="flex items-start gap-2 max-w-md"
    >
      <Step label="Inquired" done={inquired} />
      <Connector done={quoted} />
      <Step label="Quoted" done={quoted} />
      <Connector done={contractRequested} />
      <Step label="Requested" done={contractRequested} />
      <Connector done={booked} />
      <Step label="Booked" done={booked} />
    </div>
  );
}
